module.exports = __webpack_public_path__ + "img/37565c6.jpg";